import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import { countryListSchema, type Country } from '@/lib/schemas/location';

/**
 * The country reference list, from the API rather than a copy kept here.
 *
 * It changes about never, so it is cached for the whole session — refetching it
 * on every mount of the registration form would be pure waste.
 */
export function useCountries(): UseQueryResult<Country[], Error> {
  return useQuery({
    queryKey: queryKeys.countries,
    queryFn: ({ signal }) => apiClient.get('/locations/countries', countryListSchema, { signal }),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
}
